<div class="parallax">
    
    <div class="gradesHeaderImg container">
      <div class="heroContent english">
        <h1>My Classroom Economy overview</h1>
      </div>
      <div class="heroContent spanish hidden">
        <h1>Descripción de My Classroom Economy</h1>
      </div>
    </div>
    <section class="backgroundImages" style="top: 0px;">
      <div class="centeredDiv zoom-images">
      <div class="heroOverlay" data-start="background:rgba(0, 0, 0, 0)" data-600-start="background:rgba(0, 0, 0, 0.5)" anchor-target="body"></div>
        <div id="overviewHeader" class="backgroundImage" data-start="transform: scale(1)" data-600-start="transform: scale(1.3)" anchor-target="body">

          <span class="english" role="img" aria-label="My Classroom Economy overview"></span>
          <span class="spanish hidden" role="img" aria-label="Descripción de My Classroom Economy"></span>
        </div>
      </div>
    </section>
      
  <div class="container main k1" id="skrollr-body">
    <div class="col-md-11 english body-styling">
      <h2 class="caption_headings">My Classroom Economy can work for any grade level.</h2>
      <p>Tailored to the learning ability of your students, the program has the same overall objectives for
        all grades—to instill basic financial responsibility and teach the value of delayed gratification.</p>
      <p><strong>The core principle is simple:</strong> Students earn and spend money in a simulated microeconomy. As the
        grade levels increase, we incorporate additional financial concepts. For example, students in all
        grades pay rent for their desks, but students in middle school also pay an electricity bill as well
        as taxes. For high school students, we include experiential learning activities targeted at
        teaching the foundations of investing and purchasing insurance.</p>
      <p>The program is carefully designed to overlay—not interrupt—your curriculum. Therefore, it can
        be implemented by any teacher, in any subject matter. And don't forget, materials are free and
        customized by grade level to allow broad access to the program.</p>
    </div>
    <div class="col-md-11 spanish hidden body-styling">
        <h2 class="caption_headings">My Classroom Economy puede funcionar para cualquier nivel de grado.</h2>
        <p>Adaptado a la capacidad de aprendizaje de sus alumnos, el programa tiene los mismos objetivos generales para todos los grados: inculcar la responsabilidad financiera básica y enseñar el valor de la gratificación.</p>
        <p><strong>El objetivo central es simple:</strong> Los estudiantes ganan y gastan dinero en una microeconomía simulada. A medida que aumentan los niveles de grado, incorporamos conceptos financieros adicionales. Por ejemplo, los estudiantes de todos los grados pagan el alquiler de sus escritorios, pero los estudiantes de la escuela intermedia también pagan una factura de electricidad e impuestos. Para los estudiantes de secundaria, incluimos actividades de aprendizaje experimental dirigidas a enseñar los fundamentos de la inversión y la compra de seguros.</p>
        <p>El programa está cuidadosamente diseñado para complementar, no interrumpir, su plan de estudios. Por lo tanto, puede ser implementado por cualquier profesor, en cualquier materia. Y no lo olvide, los materiales son gratuitos y personalizados por nivel de grado para permitir un amplio acceso al programa.</p>
      </div>
    <div class="col-md-12">
      <div class="tabs vid_player">
        <c11n-tabs [activeItem]="'how_it_works'" class="grades-economic-system-table english">
          <c11n-tab-panel tabindex="-1" id="how_it_works" class="tab-content" labelText="How it works">
            <app-video-player [videoSrc]="'5lj00g9fyq'" [title]="'How it works'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
          </c11n-tab-panel>
          <c11n-tab-panel tabindex="-1" id="bonuses" class="tab-content" labelText="Bonuses">
            <app-video-player [videoSrc]="'4nn0re4bb6'" [title]="'Bonuses'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
          </c11n-tab-panel>
          <c11n-tab-panel tabindex="-1" id="rent_and_fines" class="tab-content" labelText="Rent and fines">
            <app-video-player [videoSrc]="'r5k5s835vl'" [title]="'Rent and fines'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
          </c11n-tab-panel>
          <c11n-tab-panel tabindex="-1" id="bills_and_taxes" class="tab-content" labelText="Bills and taxes">
            <app-video-player [videoSrc]="'3oe1maewfp'" [title]="'Bills and taxes'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
          </c11n-tab-panel>
          <c11n-tab-panel tabindex="-1" id="auctions" class="tab-content" labelText="Auctions">
            <app-video-player [videoSrc]="'3v1i87sg17'" [title]="'Auctions'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
          </c11n-tab-panel>
          <c11n-tab-panel tabindex="-1" id="insurance" class="tab-content" labelText="Insurance">
            <app-video-player [videoSrc]="'4116zs1jbd'" [title]="'Insurance'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
          </c11n-tab-panel>
        </c11n-tabs>
        <c11n-tabs [activeItem]="'how_it_works'" class="grades-economic-system-table spanish hidden">
          <c11n-tab-panel tabindex="-1" id="how_it_works" class="tab-content" labelText="Como funciona">
            <app-video-player [videoSrc]="'5lj00g9fyq'" [title]="'Como funciona'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
          </c11n-tab-panel>
          <c11n-tab-panel tabindex="-1" id="bonuses" class="tab-content" labelText="Bonos">
            <app-video-player [videoSrc]="'4nn0re4bb6'" [title]="'Bonos'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
          </c11n-tab-panel>
          <c11n-tab-panel tabindex="-1" id="rent_and_fines" class="tab-content" labelText="Renta y Multas">
            <app-video-player [videoSrc]="'r5k5s835vl'" [title]="'Renta y Multas'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
          </c11n-tab-panel>
          <c11n-tab-panel tabindex="-1" id="bills_and_taxes" class="tab-content" labelText="Facturas e impuestos">
            <app-video-player [videoSrc]="'3oe1maewfp'" [title]="'Facturas e impuestos'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
          </c11n-tab-panel>
          <c11n-tab-panel tabindex="-1" id="auctions" class="tab-content" labelText="Subastas">
            <app-video-player [videoSrc]="'3v1i87sg17'" [title]="'Subastas'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
          </c11n-tab-panel>
          <c11n-tab-panel tabindex="-1" id="insurance" class="tab-content" labelText="Seguros">
            <app-video-player [videoSrc]="'4116zs1jbd'" [title]="'Seguros'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
          </c11n-tab-panel>
        </c11n-tabs>
      </div>
    </div>
    
    <div class="small_vid_player">
    <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
    <div class="panel panel-default">
      <a role="tab" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-controls="collapseOne">
          <div class="panel-heading english" id="headingOne">
                <h4 class="panel-title">Introduction</h4>
        </div>
        <div class="panel-heading spanish hidden" role="tab" id="headingOne">
                <h4 class="panel-title">Introducción</h4>
          </div>
      </a>
      <div id="collapseOne" class="panel-collapse collapse in">
        <div class="panel-body english">
          <app-video-player [videoSrc]="'1br002dj72'" [title]="'Introduction'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
        </div>
        <div class="panel-body spanish hidden">
          <app-video-player [videoSrc]="'1br002dj72'" [title]="'Introducción'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
        <a class="collapsed" role="tab" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-controls="collapseTwo">
          <div class="panel-heading english" id="headingTwo">
                <h4 class="panel-title">How it works</h4>
        </div>
        <div class="panel-heading spanish hidden" role="tab" id="headingTwo">
                <h4 class="panel-title">Como funciona</h4>
          </div>
      </a>
      <div id="collapseTwo" class="panel-collapse collapse">
        <div class="panel-body english">
          <app-video-player [videoSrc]="'5lj00g9fyq'" [title]="'How it works'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
        </div>
        <div class="panel-body spanish hidden">
          <app-video-player [videoSrc]="'5lj00g9fyq'" [title]="'Como funciona'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
        <a class="collapsed" role="tab" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-controls="collapseThree">
          <div class="panel-heading english" id="headingThree">
            <h4 class="panel-title">Bonuses</h4>
          </div>
          <div class="panel-heading spanish hidden" role="tab" id="headingThree">
              <h4 class="panel-title">Bonos</h4>
          </div>
      </a>
      <div id="collapseThree" class="panel-collapse collapse">
        <div class="panel-body english">
          <app-video-player [videoSrc]="'4nn0re4bb6'" [title]="'Bonuses'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
        </div>
        <div class="panel-body spanish hidden">
          <app-video-player [videoSrc]="'4nn0re4bb6'" [title]="'Bonos'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
        </div>
      </div>
    </div>
     <div class="panel panel-default">
     <a class="collapsed" role="tab" data-toggle="collapse" data-parent="#accordion" href="#collapseFour" aria-controls="collapseFour">
          <div class="panel-heading english" id="headingFive">
            <h4 class="panel-title">Rent and fines</h4>
          </div>
          <div class="panel-heading spanish hidden" role="tab" id="headingFive">
              <h4 class="panel-title">Renta y Multas</h4>
          </div>
      </a>
      <div id="collapseFour" class="panel-collapse collapse">
        <div class="panel-body english">
          <app-video-player [videoSrc]="'r5k5s835vl'" [title]="'Rent and fines'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
        </div>
        <div class="panel-body spanish hidden">
          <app-video-player [videoSrc]="'r5k5s835vl'" [title]="'Renta y Multas'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
        </div>
      </div>
    </div>
     <div class="panel panel-default">
     <a class="collapsed" role="tab" data-toggle="collapse" data-parent="#accordion" href="#collapseFive" aria-controls="collapseFive">
          <div class="panel-heading english" id="headingFive">
            <h4 class="panel-title">Bills and taxes</h4>
          </div>
          <div class="panel-heading spanish hidden" role="tab" id="headingFive">
              <h4 class="panel-title">Facturas e impuestos</h4>
          </div>
      </a>
      <div id="collapseFive" class="panel-collapse collapse">
        <div class="panel-body english">
          <app-video-player [videoSrc]="'3oe1maewfp'" [title]="'Bills and taxes'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
        </div>
        <div class="panel-body spanish hidden">
          <app-video-player [videoSrc]="'3oe1maewfp'" [title]="'Facturas e impuestos'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
    <a class="collapsed" role="tab" data-toggle="collapse" data-parent="#accordion" href="#collapseSix" aria-controls="collapseSix">
          <div class="panel-heading english" id="headingSix">
            <h4 class="panel-title">Auctions</h4>
          </div>
          <div class="panel-heading spanish hidden" role="tab" id="headingSix">
              <h4 class="panel-title">Subastas</h4>
          </div>
      </a>
      <div id="collapseSix" class="panel-collapse collapse">
        <div class="panel-body english">
          <app-video-player [videoSrc]="'3v1i87sg17'" [title]="'Auctions'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
        </div>
        <div class="panel-body spanish hidden">
          <app-video-player [videoSrc]="'3v1i87sg17'" [title]="'Subastas'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
    <a class="collapsed" role="tab" data-toggle="collapse" data-parent="#accordion" href="#collapseSeven" aria-controls="collapseSeven">
      <div class="panel-heading english" id="headingSeven">
        <h4 class="panel-title">Insurance</h4>
      </div>
      <div class="panel-heading spanish hidden" role="tab" id="headingSeven">
        <h4 class="panel-title">Seguros</h4>
      </div>
     </a>
      <div id="collapseSeven" class="panel-collapse collapse">
        <div class="panel-body english">
          <app-video-player [videoSrc]="'4116zs1jbd'" [title]="'Insurance'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
        </div>
        <div class="panel-body spanish hidden">
          <app-video-player [videoSrc]="'4116zs1jbd'" [title]="'Seguros'" [videoHeight]="622" [videoWidth]="1106"></app-video-player>
        </div>
      </div>
    </div>
  </div>
  </div>
  
  </div>
  </div>